import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  isAuthenticated: boolean
  userRole: string | null
  username: string | null
  token: string | null
  login: (role: string, username: string, token?: string) => void
  logout: () => void
  setUser: (user: { authenticated: boolean; role: string | null; username?: string | null; token?: string | null }) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      userRole: null,
      username: null,
      token: null,

      login: (role, username, token) => {
        set({ isAuthenticated: true, userRole: role, username, token: token || null })
      },

      logout: () => {
        set({ isAuthenticated: false, userRole: null, username: null, token: null })
      },

      setUser: (user) => {
        set((state) => ({
          isAuthenticated: user.authenticated,
          userRole: user.role,
          username: user.username !== undefined ? user.username : state.username,
          token: user.token !== undefined ? user.token : state.token,
        }))
      },
    }),
    {
      name: 'dc-cable-auth',
    },
  ),
)
